<template>
  <div :style="{...wrapStyle}">
    <span v-if="haveDay || onlyHaveDay" :class="getCss('d_sp')" :style="{...fontStyle}">{{ countdownDay }}</span>
    <span v-if="haveDay || onlyHaveDay" :style="{...delimiterStyleDay}" :class="getCss('delimiter')">{{
        delimiterDay
      }}</span>
    <span v-if="!onlyHaveDay" :class="getCss('h_sp')" :style="{...fontStyle}">{{ countdownHour }}</span>
    <span v-if="!onlyHaveDay" :style="{...delimiterStyle}" :class="getCss('delimiter')">{{ delimiter }}</span>
    <span v-if="!onlyHaveDay" :class="getCss('m_sp')" :style="{...fontStyle}">{{ countdownMinute }}</span>
    <span v-if="!onlyHaveDay" :style="{...delimiterStyle}" :class="getCss('delimiter')">{{ delimiter }}</span>
    <span v-if="!onlyHaveDay" :class="getCss('s_sp')" :style="{...fontStyle}">{{ countdownSecond }}</span>
  </div>
</template>
<script>
import '@tencent/ceiba-base-components/index.scss';
import {componentBaseMixin} from '@tencent/ceiba-base-components';
import Vue from 'vue';

export default {
  name: 'CCountdown',
  mixins: [componentBaseMixin],
  data() {
    return {
      cssPrefix: 'countdown-',
      now: NaN,
      getFinishTime: 0,
    };
  },
  computed: {
    // 是否   true 倒序  默认是   false 顺序
    isTimeOrderByDesc() {
      return this.configurationData.isTimeOrderByDesc;
    },

    haveDay() {
      console.log(this.styles.countdown.config.haveDay);
      return this.styles.countdown.config.haveDay;
    },
    onlyHaveDay() {
      return this.styles.countdown.config.onlyHaveDay;
    },
    delimiter() {
      return parseInt(this.styles.countdown.config.delimiterType, 10) === 1 ? this.styles.countdown.config.delimiter || ':' : '';
    },
    delimiterDay() {
      return parseInt(this.styles.countdown.config.delimiterType, 10) === 3 ? '' : this.styles.countdown.config.delimiterDay || '天';
    },
    wrapStyle() {
      return {
        ...this.styles.base,
        backgroundImage: `url(${this.configurationData.countdownBackgroundImg || ''})`,
        'text-align': 'center',
        display: 'flex',
      };
    },
    delimiterStyle() {
      if (parseInt(this.styles.countdown.config.delimiterType, 10) === 2) {
        return {
          backgroundImage: `url(${this.styles.countdown.config.delimiterImg || ''})`,
          'line-height': this.styles.base.height,
          width: this.styles.countdown.config.haveDay ? `${100 / 7}%` : `${100 / 5}%`,
        };
      }
      return {
        ...this.styles.topFontStyle,
        'line-height': this.styles.base.height,
        width: this.styles.countdown.config.haveDay ? `${100 / 7}%` : `${100 / 5}%`,
      };
    },
    delimiterStyleDay() {
      if (parseInt(this.styles.countdown.config.delimiterType, 10) === 2) {
        return {
          backgroundImage: `url(${this.styles.countdown.config.delimiterDayImg || ''})`,
          'line-height': this.styles.base.height,
          width: this.styles.countdown.config.haveDay ? `${100 / 7}%` : `${100 / 5}%`,
        };
      }
      return {
        ...this.styles.topFontStyle,
        'line-height': this.styles.base.height,
        width: this.styles.countdown.config.haveDay ? `${100 / 7}%` : `${100 / 5}%`,
      };
    },
    fontStyle() {
      let getWidth = this.styles.countdown.config.haveDay ? 100 / 7 : 20;
      if (this.onlyHaveDay) {
        getWidth = 100;
      }
      return {
        ...this.styles.topFontStyle,
        width: `${getWidth}%`,
        'line-height': this.styles.base.height,
        'text-align': 'center',
      };
    },
    endTime() {
      // 倒计时不会小于0，也就是说countdown最小值是0
      return this.styles.countdown.config.endTime;
    },
    // 剩余的毫秒数
    countdown() {
      // 倒计时不会小于0，也就是说countdown最小值是0
      return Math.max(0, this.getFinishTime - this.now);
    },
    // 天
    countdownDay() {
      // 距离是多少天
      if (this.isTimeOrderByDesc) {
        const {cycleType} = this.styles.countdown.config;
        if (cycleType === 2) {
          let day = parseInt(parseInt(this.countdown, 10) / 8.64e7, 10);
          if (day === 0) {
            day = 7;
          }
          return day - parseInt(this.configurationData.isTimeOrderByNum, 10);
        }
      }
      // padStart是用于补位
      return String.prototype.padStart.call(
        (this.countdown / 8.64e7) | 0,
        2,
        '0',
      );
    },
    // 时
    countdownHour() {
      // padStart是用于补位
      if (this.haveDay) {
        return String.prototype.padStart.call(
          ((this.countdown / 3.6e6) % 24) | 0,
          2,
          '0',
        );
      }
      return String.prototype.padStart.call(
        (this.countdown / 3.6e6) | 0,
        2,
        '0',
      );
    },
    // 分
    countdownMinute() {
      return String.prototype.padStart.call(
        ((this.countdown % 3.6e6) / 6e4) | 0,
        2,
        '0',
      );
    },
    // 秒
    countdownSecond() {
      return String.prototype.padStart.call(
        ((this.countdown % 6e4) / 1e3) | 0,
        2,
        '0',
      );
    },
  },
  // 监听时间到了：
  watch: {
    countdown(countdown) {
      if (0 === countdown) {
        // alert('时间到了');
        Vue.prototype.$eventBus.$emit('ceiba:common:events:countdown', null);
        // this.styles.countdown.config.isCycle ? this.initialize() : '';
      }
    },
    endTime: 'initialize',
  },
  async mounted() {
    await this.initialize();
    console.log(this.styles.countdown.config);
  },
  created() {
    const update = () => {
      // 也是循环调用自身,这次会在一开始就更新this.now
      this.now = new Date().getTime();
      // requestAnimationFrame接受一个参数，这个参数是一个函数
      // 因为在update里调用requestAnimationFrame(update)，相当于设定下次屏幕刷新前执行一下update
      // 那么下次执行update的时候，又会设置下一帧要调用update
      // requestAnimationFrame在下次屏幕刷新前,所以不同的显示器，刷新率不一样，调用的次数也不同,但是，能保证，每次重绘的时候总是最新的时间
      if (this.configurationData.onlyHaveDay) {
        return;
      }
      requestAnimationFrame(update);
    };
    update();
  },
  methods: {
    async initialize() {  // 初始化 获取倒计时结束时间
      // 设置的倒计时时间
      // eslint-disable-next-line prefer-const
      let {endTime, cycleType, dNum, hNum, mNum, sNum} = this.styles.countdown.config;
      if(dNum > 0){
        dNum = dNum - 1;
      }
      console.log('this.styles.countdown.config', this.styles.countdown.config);
      if (this.$platform.isIos) {
        endTime = endTime.replace(/-/g, '/');
      }
      const nowDay = new Date().getDate();// 当前日
      const nowMonth = new Date().getMonth(); // 当前月
      const nowYear = new Date().getFullYear(); // 当前年
      const nowDayOfWeek = new Date().getDay() - 1; // 今天本周的第几天
      // const dayLong = 24 * 60 * 60 * 1000;
      let finishTime = 0;
      switch (cycleType) {
        case 1:  // 每日的时间点
          finishTime = new Date(new Date(new Date().getTime()).setHours(hNum, mNum, sNum, 0)).getTime();// 当日的开始时间
          if (this.now > finishTime) {
            finishTime += 86400000;// 加上一日的时间
          }
          break;
        case 2:  // 每周的时间点
          // eslint-disable-next-line no-case-declarations
          const weekStartDate = new Date(nowYear, nowMonth, nowDay - nowDayOfWeek).getTime(); // 当前周的开始时间
          // eslint-disable-next-line no-case-declarations
          // eslint-disable-next-line no-case-declarations
          const countWeekNum = (dNum * 86400 + hNum * 3600 + mNum * 60 + sNum) * 1000;
          finishTime = countWeekNum + weekStartDate;
          if (this.now > finishTime) {
            finishTime += 7 * 86400000; // 加上一周的时间
          }
          break;
        case 3:  // 每月的时间点
          // eslint-disable-next-line no-case-declarations
          const monthStartDateTime = new Date(nowYear, nowMonth, 1).getTime(); // 当前月的开始时间
          // eslint-disable-next-line no-case-declarations
          const countMonthNum = (dNum * 86400 + hNum * 3600 + mNum * 60 + sNum) * 1000;
          // console.log('countMonthNum', countMonthNum);
          finishTime = countMonthNum + monthStartDateTime;
          if (this.now > finishTime) {
            const monthStartDate = new Date(nowYear, nowMonth, 1);
            const monthEndDate = new Date(nowYear, nowMonth + 1, 1);
            const days = (monthEndDate - monthStartDate) / (1000 * 60 * 60 * 24);
            // return days;
            finishTime += days * 86400000; // 加上一月的时间
          }
          break;
        case 4:
          if (!endTime || endTime.length === 0) {
            this.getFinishTime = 0;
            return false;
          }
          finishTime = new Date(endTime).getTime();
          break;
        default:
          break;
      }
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      // this.isOK = false;
      console.log(finishTime);
      this.getFinishTime = finishTime;
    },
  },
};
</script>
<style lang="scss">
@import './styles.scss';
</style>
